import React, { useContext } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import get from 'lodash/get';
import { Table as BootstrapTable } from 'react-bootstrap';

// VARIABLES
import { PLACEHOLDER } from 'parts/table/variables';

// HELPERS
import { ListContext } from 'helpers/getListData';

// MAIN COMPONENT
const TotalTable = ({ columns, className }) => {
  // CONTEXT
  const { result, data } = useContext(ListContext) || {};

  // RENDER
  return columns?.length && result?.length ? (
    <BootstrapTable className={clsx('mt-4 mb-0 ms-auto border', className)} size="sm" responsive>
      <thead>
        <tr>
          {columns[0].map(({ label, width }, i) => (
            <th key={i} style={{ width, minWidth: width }}>
              {label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {columns.map((row, i) => (
          <tr key={i}>
            {row.map(
              (
                {
                  className, //
                  component: Component,
                  key,
                  value: controlledValue
                },
                j
              ) => {
                const value = controlledValue || get(data, key);
                return (
                  <td key={j} className={className}>
                    {Component ? <Component placeholder={PLACEHOLDER} value={value} /> : value}
                  </td>
                );
              }
            )}
          </tr>
        ))}
      </tbody>
    </BootstrapTable>
  ) : null;
};

// EXPORT
export default TotalTable;
